export const getItemInvalidationTag = <ItemId extends string, Tag extends string>(
  itemId: ItemId,
  tagType: Tag,
) => ({ type: tagType, id: itemId });
